const initHeader = () => {
    const header = document.querySelector(".gg-navigation");
    let menuLevelTexts = []; // Global array to store menu texts
  
    if (!header) {
        return;
    }
  
    const headerIsSimple = header.classList.contains("gg-navigation-v2");
  
    if (headerIsSimple) {
        document.body.classList.add("gg-navigation--initialized");
  
        return;
    }
  
    const menu = header.querySelector(".gg-navigation__main-menu");
    const search = header.querySelector(".gravity-block-search");
    const primaryButton = header.querySelector(
        ".gg-navigation__primary-button"
    );
    const drawerLogo = header.querySelector(".gg-navigation__drawer-logo");
  
    const moveItemsToDrawer = (itemsBefore, itemsAfter) => {
        itemsBefore.forEach((item) => menu.gravity.registerBeforeWrapper(item));
        itemsAfter.forEach((item) => menu.gravity.registerAfterWrapper(item));
        menu.gravity.moveExternalElements();
        document.body.classList.add("gg-navigation--initialized");
    };
  
    moveItemsToDrawer([drawerLogo], [primaryButton]);
  
    if (search) {
        const searchObserver = new MutationObserver((mutations) => {
            mutations.forEach(({ target, attributeName }) => {
                if (attributeName === "class") {
                    header.classList.toggle(
                        "active-search",
                        target.classList.contains("gravity-block-search--show")
                    );
                }
            });
        });
  
        searchObserver.observe(search, { attributes: true });
    }
  
    // Function to calculate and set min-height for flyout menu
    const setFlyoutMenuMinHeight = () => {
        const isMobile = window.innerWidth < 1025;
        
        const desktopMenu = document.querySelector('.gg-flyout-menu--custom');
        const mobileMenu = document.querySelector('.gg-custom-sub-menu');
        
        if (desktopMenu) desktopMenu.style.minHeight = '';
        if (mobileMenu) mobileMenu.style.minHeight = '';
        
        const targetMenu = isMobile ? mobileMenu : desktopMenu;
            
        if (!targetMenu) {
            return;
        }
  
        const ulElements = document.querySelectorAll('.gg-flyout-menu--custom ul li ul li ul');
        
        if (ulElements.length === 0) {
            return;
        }
  
        let maxTotalHeight = 0;
        const gapSize = isMobile ? 16 : 0;
        const extraHeight = isMobile ? 80 : 120;
  
        ulElements.forEach(ul => {
            const liElements = ul.querySelectorAll('li');
            let ulTotalHeight = 0;
            
            liElements.forEach((li, index) => {
                const liHeight = li.offsetHeight;
                ulTotalHeight += liHeight;
                
                if (index < liElements.length - 1) {
                    ulTotalHeight += gapSize;
                }
            });
            
            if (ulTotalHeight > maxTotalHeight) {
                maxTotalHeight = ulTotalHeight;
            }
        });
  
        const finalHeight = maxTotalHeight + extraHeight;
  
        targetMenu.style.minHeight = `${finalHeight}px`;
        targetMenu.style.setProperty('--flyout-after-height', `${finalHeight}px`);
    };
  
    // Mobile menu functionality
    const handleMobileMenu = () => {
        const menuItemsButton = header.querySelectorAll(".gravity-block-navigation__item--has-children button");
        
        const createBackButton = (container) => {
            const backButton = document.createElement('button');
            backButton.className = 'button-back-main-menu';
            backButton.textContent = 'Back';
            container.insertBefore(backButton, container.firstChild);
            return backButton;
        };
  
        const handleBackButtonClick = (backButton) => {
            const expandedMenus = document.querySelectorAll('ul.expand-sub-menu');
            if (expandedMenus.length > 0) {
                const lastExpandedMenu = expandedMenus[expandedMenus.length - 1];
                lastExpandedMenu.classList.remove('expand-sub-menu');
                const parentButton = lastExpandedMenu.closest('.gravity-block-navigation__item--has-children').querySelector('button');
                if (parentButton) {
                    parentButton.setAttribute('aria-expanded', 'false');
                }
  
                // Update menuText when clicking back
                const menuText = document.querySelector('.gg-custom-sub-menu .wp-block-cover__inner-container .text-menu--level');
                const currentLevel = document.querySelectorAll('ul.expand-sub-menu').length;
                if (menuText && menuLevelTexts[currentLevel]) {
                    menuText.textContent = menuLevelTexts[currentLevel];
                }
  
                const parentItem = lastExpandedMenu.closest('.gravity-block-navigation__item--has-children');
                if (parentItem) {
                    setTimeout(() => {
                        parentItem.classList.remove('li-expand-sub-menu');
                    }, 320);
                }
  
                const remainingExpandedMenus = document.querySelectorAll('ul.expand-sub-menu');
                if (remainingExpandedMenus.length === 0) {
                    backButton.classList.add('remove-button');
                }
            }
        };
  
        const handleMenuItemClick = (item) => {
            if (window.innerWidth < 1025) {
                const parentItem = item.closest('.gravity-block-navigation__item--has-children');
                const subMenu = parentItem.querySelector('ul');
                if (subMenu) {
                    subMenu.classList.add('expand-sub-menu');
                    parentItem.classList.add('li-expand-sub-menu');
                    item.setAttribute('aria-expanded', 'true');
  
                    const allMenuTexts = document.querySelectorAll('.text-menu--level');
                    allMenuTexts.forEach((text, index) => {
                        // Store all texts in array
                        if (!menuLevelTexts.includes(text.textContent)) {
                            menuLevelTexts.push(text.textContent);
                        }
                    });
  
                    const menuText = item.closest('.wp-block-cover__inner-container')?.querySelector('.text-menu--level');
                    const expandedMenusCount = document.querySelectorAll('ul.expand-sub-menu').length;
                    
                    if (menuText && allMenuTexts[expandedMenusCount]) {
                        menuText.textContent = allMenuTexts[expandedMenusCount].textContent;
                    }
  
                    const customSubMenu = document.querySelector('.gg-custom-sub-menu .wp-block-cover__inner-container');
                    const existingBackButton = customSubMenu?.querySelector('.button-back-main-menu');
                    
                    if (existingBackButton) {
                        existingBackButton.classList.remove('remove-button');
                    } else if (customSubMenu) {
                        const backButton = createBackButton(customSubMenu);
                        backButton.addEventListener('click', () => handleBackButtonClick(backButton));
  
                        const hasExpandedMenus = document.querySelectorAll('ul.expand-sub-menu').length > 0;
                        if (!hasExpandedMenus) {
                            backButton.classList.add('remove-button');
                        }
                    }
                }
            }
        };
  
        menuItemsButton.forEach(item => {
            item.addEventListener("click", () => handleMenuItemClick(item));
        });
    };
  
    // Handle mobile toggle button click
    const handleMobileToggleClick = () => {
        const mobileToggleButton = document.querySelector('.gravity-block-navigation__mobile-toggle');
        
        if (mobileToggleButton) {
            mobileToggleButton.addEventListener('click', () => {
                if (window.innerWidth < 1025) {
                    setTimeout(() => {
                        setFlyoutMenuMinHeight();
                    }, 100);
                }
            });
        }
    };
  
    const handleExpandSubMenuDesktop = () => {
        if (window.innerWidth < 1025) {
            return;
        }
        const li1 = document.querySelectorAll('.gg-flyout-menu--custom nav > ul > li.gravity-block-navigation__item--has-children:has(>ul>li)');
        const li2 = document.querySelectorAll('.gg-flyout-menu--custom ul > li.gravity-block-navigation__item--has-children li.gravity-block-navigation__item--has-children:has(>ul>li)');
        const megaMenu = document.querySelector('.gravity-block-navigation__mega-menu:has(>.gg-flyout-menu--custom)');
        li1.forEach(li => {
            li.addEventListener('mouseenter', () => {
                megaMenu.classList.add('expand-col-2');
                megaMenu.classList.remove('expand-col-3');
            });
            li.addEventListener('mouseleave', () => {
                megaMenu.classList.remove('expand-col-2');
            });
        });
        li2.forEach(li => {
            li.addEventListener('mouseenter', () => {
                megaMenu.classList.add('expand-col-3');
            });
            li.addEventListener('mouseleave', () => {
                megaMenu.classList.remove('expand-col-3');
            });
        });
    }
  
    handleMobileMenu();
    handleMobileToggleClick();
  
    setFlyoutMenuMinHeight();
    handleExpandSubMenuDesktop();
  
    window.addEventListener('resize', () => {
        setFlyoutMenuMinHeight();
        handleExpandSubMenuDesktop();
    });
  };
  
  export default initHeader;
  